<template>
    <div :class="['hanzo-hairline', classes([direction, { [status]: status }])]">
        <div :class="classes('title')" :style="titleStyle">
            <slot></slot>
        </div>
        <div :class="classes('circle-container')">
            <slot v-if="status === 'process'" name="active-icon">
                <h-icon 
                    :class="classes('icon')" 
                    :type="activeIcon"
                    :color="activeColor"
                ></h-icon>
            </slot>
            <slot v-else name="inactive-icon">
                <h-icon 
                    v-if="inactiveIcon"
                    :class="classes('icon')" 
                    :type="inactiveIcon"
                    :style="stepStyle"
                ></h-icon>
                <i v-else :class="classes('circle')"></i>
            </slot>
        </div>
        <div :class="classes('line')" />
    </div>
</template>
<script>
import { useBEM } from '../../../common/utils/classnames';
import hIcon from '../../icon/index';
let classnames = useBEM( 'hanzo-step' );
export default {
    name: 'h-step',
    beforeCreate() {
        const { steps } = this.$parent;
        const index = this.$parent.$slots.default.indexOf(this.$vnode);
        steps.splice(index === -1 ? steps.length : index, 0, this);
    },

    beforeDestroy() {
        const index = this.$parent.steps.indexOf(this);
        if (index > -1) {
        this.$parent.steps.splice(index, 1);
        }
    },
    components: {
        hIcon
    },
    props: {
        stepStyle: Object
    },
    computed: {
        activeIcon() {
            return this.$parent.activeIcon;
        },
        activeColor() {
            return this.$parent.activeColor;
        },
        inactiveIcon() {
            return this.$parent.inactiveIcon;
        },
        direction() {
            return this.$parent.direction;
        },
        titleStyle() {
            return this.status === 'process' && { color: this.activeColor };
        },
        status() {
            const index = this.$parent.steps.indexOf(this);
            const { active } = this.$parent;

            if (index < active) {
                return 'finish';
            }
            if (index === active) {
                return 'process';
            }
        }
    },
    methods: {
        classes( arg ) {
            return classnames( arg );
        }
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
